var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('a',{attrs:{"href":_vm.externalLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.$i18n('quiz.wikilink')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }